export class Alert {
    type: AlertType;
    message: string;
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}


// WEBPACK FOOTER //
// ./src/app/main/interfaces/alert.ts